import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../apiSetup/apiCall';

export const fetchEditAdminForm = createAsyncThunk('editAdmin/fetchEditAdminForm', async (selectedAdminEdit, { rejectWithValue }) => {
  try {
    const response = await api.get(`${selectedAdminEdit}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching edit admin form', error);
    throw rejectWithValue(error);
  }
});


const EditAdminSlice = createSlice({
  name: "editAdmin",
  initialState: {
    data: [],
    isLoading: false,
    error: null,
  },
  reducers: {
    setAdminId: (state, action) => {
      state.adminId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEditAdminForm.pending, (state) => {
        state.isLoading = true;
        state.error = false;
      })
      .addCase(fetchEditAdminForm.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchEditAdminForm.rejected, (state, action) => {
        state.isLoading = false;
        state.data = [];
        state.error = true;
      });
  },
});

export const { setAdminId } = EditAdminSlice.actions;
export default EditAdminSlice.reducer;

